var pym = require("./lib/pym");
require("./lib/webfonts");
var classify = require("./lib/helpers/classify");
var dot = require("./lib/dot");
var template = dot.compile(require("./_table.html"));

// If sortable:
// window.Tablesort = require('./lib/tablesort');
// Tablesort(document.querySelector("#state-table"))

var onWindowLoaded = function () {
  const buttons = document.querySelectorAll(".input");
  buttons.forEach(b => {
    b.addEventListener("click", renderTable);
  });
  document.querySelector("#selector").addEventListener("change", renderTable);

  document.querySelector("#the-naples-colloquium").click()

  pym.then(child => {
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

let details = {};
for (const event in DETAILS) {
  details[classify(event)] = DETAILS[event];
}

const renderTable = function(e) {
  const graphicEl = document.querySelector("#table");
  let data = {};
  data.attendees = DATA.filter(d => classify(d.Event) === e.target.value);
  data.event = details[e.target.value];
  var content = template(data);

  // Make sure filter buttons and dropdown menu are matching
  // in case user switches between mobile and desktop
  document.querySelector("#selector").value = e.target.value;
  document.querySelectorAll(".input").forEach(d => {
    d.checked = false;
  });
  document.querySelector("#" + e.target.value).checked = true;

  // Activate the "Show response" buttons
  graphicEl.innerHTML = content;
  document.querySelectorAll(".response-button").forEach(b => {
    b.addEventListener("click", (e) => {
      e.target.parentElement.classList.add("expanded");
      document.querySelector("#" + e.target.dataset.id).classList.add("show");
      pym.then(child => child.sendHeight());
    });
  });

  pym.then(child => child.sendHeight());
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);